/**
 * Triggers a one-row CSV download in the browser (header line only, for supplier import templates).
 * @param {string} headerRow - Single line of comma-separated column names, no trailing newline required.
 *   Columns are matched by name on import, so their order here does not matter to the parser —
 *   this header row simply lists every column name the import recognises.
 * @param {string} filename - Downloaded file name (e.g. suppliers-import-template.csv).
 */
export function downloadSupplierImportTemplateCsv(headerRow, filename) {
  const blob = new Blob([`${headerRow}\n`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
